// extracted by mini-css-extract-plugin
export default {"controls":"PrayerCalendarPage_controls__Nov6m","preview":"PrayerCalendarPage_preview__E7hMI"};